import { Controller } from "@hotwired/stimulus"

// The Contact section's rows (contacts/_reach). They arrive short - birthday,
// a work address, a number, each drawn first by CSS order - with the rest
// hidden behind "+N more", like Work's "+2 earlier roles". Expanding drops the
// short view, so every row shows in the order the server wrote them:
// addresses, numbers, profiles, birthday.
export default class extends Controller {
    static targets = ["more"]

    // "+3 more" shows the full list; then "Show less" brings the short view
    // back (2026-10-14).
    expand(event) {
        event?.preventDefault()
        const short = this.element.classList.toggle("is-short")
        if (!this.hasMoreTarget) return

        this.moreLabel ||= this.moreTarget.textContent.trim()
        this.moreTarget.textContent = short ? this.moreLabel : "Show less"
        this.moreTarget.setAttribute("aria-expanded", short ? "false" : "true")
    }
}
